export const avisosConstants = {
  INDEX_REQUEST: 'AVISOS_INDEX_REQUEST',
  INDEX_SUCCESS: 'AVISOS_INDEX_SUCCESS',
  INDEX_FAILURE: 'AVISOS_INDEX_FAILURE', 
};
